export const sendAdobeData = (digitalData?: Record<string, unknown>) => {
  window.digitalData = digitalData;
  const windowEvent = new CustomEvent('dataLayerUpdated', {
    detail: digitalData
  });
  window.dispatchEvent(windowEvent);

  window._satellite &&
    window._satellite.track &&
    window._satellite.track('new_page_view', digitalData);
};

export const sendAdobeEvent = (event: Record<string, unknown>): void => {
  if (window._DATADOG_SYNTHETICS_BROWSER) {
    return;
  }

  const events = [event, ...(window.digitalData?.events || [])];
  const digitalData = {
    ...window.digitalData,
    events,
    event: events[0]
  };
  sendAdobeData(digitalData);
};
